type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastItem {
  id: string;
  message: string;
  type: ToastType;
}

type ToastListener = (toasts: ToastItem[]) => void;

let toasts: ToastItem[] = [];
const listeners: ToastListener[] = [];

function notify() {
  listeners.forEach(l => l([...toasts]));
}

export function showToast(message: string, type: ToastType = 'success', duration = 3000) {
  const id = Date.now().toString() + Math.random();
  toasts.push({ id, message, type });
  notify();
  setTimeout(() => {
    toasts = toasts.filter(t => t.id !== id);
    notify();
  }, duration);
}

export function subscribeToast(listener: ToastListener) {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx >= 0) listeners.splice(idx, 1);
  };
}

export type { ToastItem, ToastType };
